(() => {
  if (customElements.get("unit-converter")) {
    return;
  }

  class UnitConverter extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        checkbox: "[data-checkbox]",
        value: "[data-value]",
      };
      this.currentUnit = "cm";
    }

    connectedCallback() {
      this.checkbox = this.querySelector(this.selectors.checkbox);

      if (!this.checkbox) {
        return;
      }
      this.values = this.querySelectorAll(this.selectors.value);
      this.checkbox.addEventListener("change", this.handleChange.bind(this));
    }

    /**
     * Handle change.
     */
    handleChange() {
      this.values.forEach((value) => {
        const currentValue = parseFloat(value.innerText);
        const convertedValue = (
          this.currentUnit === "cm" ? currentValue / 2.54 : currentValue * 2.54
        ).toFixed(2);

        value.innerText =
          this.currentUnit === "cm"
            ? convertedValue
            : this.roundUpValue(convertedValue);
      });
      this.currentUnit = this.checkbox.checked ? "cm" : "in";
    }

    /**
     * Round up the value to the nearest integer or one decimal place
     *
     * @param {String} toFixedValue
     * @returns {Number|String}
     */
    roundUpValue(toFixedValue) {
      if (toFixedValue.includes(".00")) {
        return toFixedValue.replace(".00", "");
      }

      const integerValue = Number(toFixedValue.split(".")[0]);
      const decimalValue = Number(toFixedValue.split(".")[1]);
      if (decimalValue > 95) {
        return integerValue + 1;
      }

      if (decimalValue < 5) {
        return integerValue;
      }

      return parseFloat(toFixedValue).toFixed(1);
    }
  }

  customElements.define("unit-converter", UnitConverter);
})();
